import { ReactElement } from 'react';
import { Form, Formik, FormikValues } from 'formik';
import { FlexLayout, Responsive } from '@gv/triage-components';

import DoctorImage from 'assets/images/doctor.jpg';

import * as Styles from './styles';
import { AuthLayoutProps } from './types';

/**
 * AuthLayout component is a wrapper for authentication forms, integrating Formik for form management
 *
 * @template T - A generic type extending FormikValues, representing the shape of the form values.
 */
export const AuthLayout: <T extends FormikValues>(
  props: AuthLayoutProps<T>
) => ReactElement = ({
  title,
  children,
  subtitle,
  validateOnBlur = false,
  validateOnChange = false,
  enableReinitialize = false,
  ...formikProps
}) => (
  <Styles.MainContainer>
    <Styles.ContentContainer>
      <Styles.LeftContainer>
        <FlexLayout gap={8} flexDirection="column">
          <h1 className="title">{title}</h1>
          {subtitle && <p>{subtitle}</p>}
        </FlexLayout>

        <Formik<typeof formikProps.initialValues>
          validateOnBlur={validateOnBlur}
          validateOnChange={validateOnChange}
          enableReinitialize={enableReinitialize}
          {...formikProps}
          children={(props) => {
            const render =
              // @ts-ignore
              children instanceof Function ? children(props) : children;

            return (
              <FlexLayout fullWidth flexDirection="column">
                <Form>{render}</Form>
              </FlexLayout>
            );
          }}
        />
      </Styles.LeftContainer>

      <Responsive.Desktop>
        <Styles.RightContainer>
          <Styles.ImageContainer>
            <img alt="doctor" src={DoctorImage} />
          </Styles.ImageContainer>
        </Styles.RightContainer>
      </Responsive.Desktop>
    </Styles.ContentContainer>
  </Styles.MainContainer>
);
